import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

const Oval = styled.div`
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 5px;

  ${(props) => getOvalVariant(props.variant)}
`;

const StepCounter = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 30px;
  background-color: ${theme.oldColors['palette-background-cards']};
  border-radius: 10px;

  ${(props) =>
    props.border &&
    css`
      box-shadow: 0px 0px 0px 1px ${theme.oldColors['border-grey-walkthrough']};
    `}
`;

const StepFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 30px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TooltipContainer = styled.div`
  position: absolute;
  z-index: 1;

  ${({ bottom, left, right, top, width }) => css`
    width: ${width}px;
    bottom: ${bottom};
    left: ${left};
    right: ${right};
    top: ${top};
  `}

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    ${({ position }) => styleByPosition[position]}
    ${({ border, position }) => border && shadowBorderByPosition[position]}
  }
`;

const shadowBorderByPosition = {
  bottom: css`
    filter: drop-shadow(
      0 -1px 0.6px ${theme.oldColors['border-grey-walkthrough']}
    );
  `,
  top: css`
    filter: drop-shadow(
      0 1px 0.6px ${theme.oldColors['border-grey-walkthrough']}
    );
  `,
  left: css`
    filter: drop-shadow(
      1px 0 0.6px ${theme.oldColors['border-grey-walkthrough']}
    );
  `,
  right: css`
    filter: drop-shadow(
      -1px 0 0.6px ${theme.oldColors['border-grey-walkthrough']}
    );
  `,
  rightTop: css`
    filter: drop-shadow(
      -1px 0 0.6px ${theme.oldColors['border-grey-walkthrough']}
    );
  `,
};

const styleByPosition = {
  bottom: css`
    bottom: 100%;
    margin-left: -25px;
    left: 50%;
    border-bottom: solid 25px ${theme.oldColors['palette-background-cards']};
    border-left: solid 25px transparent;
    border-right: solid 25px transparent;
  `,
  top: css`
    top: 100%;
    margin-left: -25px;
    left: 50%;
    border-top: solid 25px ${theme.oldColors['palette-background-cards']};
    border-left: solid 25px transparent;
    border-right: solid 25px transparent;
  `,
  left: css`
    left: 100%;
    top: 5%;
    border-left: solid 25px ${theme.oldColors['palette-background-cards']};
    border-top: solid 25px transparent;
    border-bottom: solid 25px transparent;
  `,
  right: css`
    right: 100%;
    top: 5%;
    border-right: solid 25px ${theme.oldColors['palette-background-cards']};
    border-top: solid 25px transparent;
    border-bottom: solid 25px transparent;
  `,
  rightTop: css`
    right: 100%;
    top: 5%;
    border-right: solid 25px ${theme.oldColors['palette-background-cards']};
    border-top: solid 25px transparent;
    border-bottom: solid 25px transparent;
  `,
};

const getOvalVariant = (variant) => {
  switch (variant) {
    case 'neutral-3':
      return css`
        background-color: ${theme.oldColors['palette-neutral-n-3']};
      `;
    case 'primary':
      return css`
        background-color: ${theme.oldColors['palette-primary-p-1-p-1']};
      `;
  }
};

const Target = styled.div`
  position: absolute;

  ${(props) =>
    props.showOverlay &&
    css`
      box-shadow: 2px 2px 2px 99999px rgba(0, 0, 0, 0.65);
    `}
  ${({ borderRadius }) =>
    borderRadius &&
    css`
      border-radius: ${borderRadius};
    `}
  z-index: 1;
  ${({ bottom, height, left, right, top, width, x, y }) => css`
    bottom: ${bottom}px;
    height: ${height}px;
    left: ${left}px;
    right: ${right}px;
    top: ${top}px;
    width: ${width}px;
    x: ${x}px;
    y: ${y}px;
  `}
`;

export {
  Oval,
  ButtonsContainer,
  StepContainer,
  StepCounter,
  StepFooter,
  TooltipContainer,
  Target,
};
